import { useCallback } from 'react';

import { EEventsType } from 'constants/enums';
import { useDashboardAnalyticsTracking } from 'hooks/useDashboardAnalyticsTracking';

enum EApiPerformanceTrackingContext {
  TAB = 'Analytics',
  PAGE = 'API Performance'
}

export enum EApiPerformanceFilterSection {
  DATES = 'dates'
}

interface ITrackFilterAppliedParams {
  section: EApiPerformanceFilterSection;
  selection: string;
}

export const useApiPerformanceTracking = () => {
  const { trackEvent, isPublisherDataReady } = useDashboardAnalyticsTracking({
    tab: EApiPerformanceTrackingContext.TAB,
    page: EApiPerformanceTrackingContext.PAGE
  });

  const trackPageDisplayed = useCallback(() => {
    trackEvent(EEventsType.DASHBOARD_PAGE_DISPLAYED);
  }, [trackEvent]);

  const trackFilterApplied = useCallback(
    ({ section, selection }: ITrackFilterAppliedParams) => {
      trackEvent(EEventsType.DASHBOARD_FILTER_APPLIED, {
        bigQueryProperties: { section, selection },
        mixpanelProperties: { section, selection }
      });
    },
    [trackEvent]
  );

  return { trackPageDisplayed, trackFilterApplied, isPublisherDataReady };
};
